import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./TopBarSeparator.less');
const cx = classnames.bind(styles);

export class TopBarSeparator extends React.Component<any, any>
{
    public render():JSX.Element
    {
        return <div className={cx('base')} />
    }
}

